<template>
  <div class="after-sale-seats">
    <router-link to="/min-side/bookings" class="after-sale-seats__back-link">
      <svg class="after-sale-seats__back-link-icon">
        <use :xlink:href="`#${chevron}`" />
      </svg>
      Til mine billetter
    </router-link>
    <h1 class="after-sale-seats__heading">
      Velg sete
      <span class="after-sale-seats__booking-number">
        Bestillingsnummer: {{ bookingNumber }}
      </span>
    </h1>
    <!-- Seat selection content will go here -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import chevron from '@/assets/icons/chevron.svg'

export default defineComponent({
  name: 'AfterSaleSeats',
  setup() {
    const route = useRoute()
    const bookingNumber = route.params.bookingNumber as string

    return {
      bookingNumber,
      chevron,
    }
  },
})
</script>

<style lang="scss" scoped>
.after-sale-seats {
  padding: 2rem;

  &__back-link {
    display: flex;
    align-items: center;
    color: $clr-text;
    text-decoration: none;
    margin-bottom: 2rem;

    &-icon {
      width: 24px;
      height: 24px;
      margin-right: 0.5rem;
      transform: rotate(90deg);
    }
  }

  &__heading {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__booking-number {
    font-size: 1rem;
    font-weight: normal;
  }
}
</style>
